import { motion } from "framer-motion";
import { Wind, SunDim, Droplets, Flame } from "lucide-react";

const risks = [
  {
    n: "01",
    icon: Wind,
    title: "une climatisation sale",
    text: "Air chargé en bactéries et moisissures, mauvaises odeurs, allergies… et jusqu'à 30 % de consommation électrique en plus. Sans entretien, l'appareil s'use prématurément.",
  },
  {
    n: "02",
    icon: SunDim,
    title: "des panneaux solaires sales",
    text: "Poussière, pollen et fientes d'oiseaux bloquent le soleil : jusqu'à 25 % de production d'électricité en moins. Votre investissement met beaucoup plus de temps à être rentable.",
  },
  {
    n: "03",
    icon: Droplets,
    title: "des gouttières bouchées",
    text: "L'eau déborde et s'infiltre partout : façades tachées, murs humides, fondations fragilisées. Une simple visite annuelle évite de très gros travaux.",
  },
  {
    n: "04",
    icon: Flame,
    title: "un ramonage oublié",
    text: "Risque d'incendie de cheminée et d'intoxication au monoxyde de carbone, un gaz invisible et mortel. Et en cas de sinistre, votre assurance peut refuser de vous couvrir sans certificat de ramonage.",
  },
];

export const Risks = () => (
  <section
    className="px-6 md:px-12 py-32 md:py-48 border-t border-white/10"
    data-testid="risks-section"
  >
    <div className="flex items-end justify-between mb-24">
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
        className="font-serif text-5xl md:text-7xl tracking-tighter leading-[0.95]"
        data-testid="risks-title"
      >
        sans entretien,<br />
        <span className="italic font-light text-gold">ça coûte plus cher.</span>
      </motion.h2>
      <p className="hidden md:block text-xs uppercase tracking-[0.3em] text-ash">
        Pourquoi entretenir ?
      </p>
    </div>

    <div className="grid md:grid-cols-2 gap-x-20">
      {risks.map((r, i) => (
        <motion.div
          key={r.n}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: (i % 2) * 0.12, ease: [0.76, 0, 0.24, 1] }}
          className="border-t border-white/10 py-12 group"
          data-testid={`risk-item-${r.n}`}
        >
          <div className="flex items-start gap-6">
            <r.icon
              className="w-6 h-6 text-gold shrink-0 mt-1 group-hover:scale-110 transition-transform duration-500"
              aria-hidden="true"
            />
            <div>
              <p className="text-xs tracking-[0.25em] text-ash mb-4">{r.n}</p>
              <h3 className="font-serif text-2xl md:text-3xl tracking-tight mb-5 group-hover:text-gold transition-colors duration-700">
                {r.title}
              </h3>
              <p className="text-sm md:text-base text-ash font-light leading-relaxed max-w-md">
                {r.text}
              </p>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
